import { UUID } from "crypto";
import { baseApi } from "./baseApi";
import { AdditionalGuarantee, NewLinkPTSAV, Person } from "@interfaces/persons";
import { Response, ResponsePagination } from "@interfaces/response";

import PersonasData from "../dataDummy/personas.json";

const personsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPersons: build.query<Array<Person>, string>({
            // query: (params) => ({
            //     url: `personas?${params}`,
            // }),
            // transformResponse: (response: ResponsePagination<Person>) => {
            //     return response.data.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("3912e960-7795-434f-bc47-d277ff43937e")) {
                    return {
                        data: PersonasData.data,
                    };
                }
                const result = await baseQuery({
                    url: `personas?${args}`,
                });

                return result.data.data;
            },
        }),
        postPerson: build.mutation<Person, Partial<Person>>({
            query: (data) => ({
                url: "personas",
                method: "POST",
                body: data,
            }),
            transformResponse: (response: Response<Person>) => {
                return response.data;
            },
        }),
        getPerson: build.query<Person, UUID>({
            query: (personId) => ({
                url: `personas/${personId}`,
            }),
            transformResponse: (response: Response<Person>) => {
                return response.data;
            },
        }),
        patchPerson: build.mutation<any, { personId: UUID; body: Partial<Person> }>({
            query: ({ personId, body }) => ({
                url: `personas/${personId}`,
                method: "PATCH",
                body,
            }),
        }),
        deletePerson: build.mutation<any, UUID | string>({
            query: (personId) => ({
                url: `personas/${personId}`,
                method: "DELETE",
            }),
        }),
        getNewMajorityShareholder: build.query<any, UUID>({
            query: (personId) => ({
                url: `personas/${personId}/cambiar_accionista_mayoritario`,
            }),
        }),
        postAdditionalGuarantee: build.mutation<any, AdditionalGuarantee>({
            query: (additionalGuarante) => ({
                url: "personas/aval_adicional",
                method: "POST",
                body: additionalGuarante,
            }),
        }),
        postNewLinkAdditionalGuarantee: build.mutation<NewLinkPTSAV, Partial<AdditionalGuarantee>>({
            query: (additionalGuarante) => ({
                url: "personas/aval_adicional/regenerar_liga",
                method: "POST",
                body: additionalGuarante,
            }),
            transformResponse: (response: Response<NewLinkPTSAV>) => {
                return response.data;
            },
        }),
    }),
});

export const {
    useGetPersonsQuery,
    useLazyGetPersonsQuery,
    usePostPersonMutation,
    usePatchPersonMutation,
    useDeletePersonMutation,
    useLazyGetPersonQuery,
    useLazyGetNewMajorityShareholderQuery,
    usePostAdditionalGuaranteeMutation,
    usePostNewLinkAdditionalGuaranteeMutation,
} = personsApi;
